module.exports = __webpack_public_path__ + "static/media/plus_full.80c6d1f2.svg";